import React from 'react';

import { type Shown, formatValue } from './format';
import type { Envelope } from './types';

type MetricSubtitleProps = { text: string; envelope?: Envelope; shown: Shown };

export default function MetricSubtitle({ text, envelope, shown }: MetricSubtitleProps) {
  return (
    <>
      {text.split(/(\{[a-z][a-z0-9_.]* first\})/g).map((part, index) => {
        const token = /^\{([a-z][a-z0-9_.]*) first\}$/.exec(part);
        if (!token) return part;
        const column = envelope?.columns.find((entry) => entry.role === 'measure' && entry.name === token[1]);
        if (!column || !envelope) return <React.Fragment key={index}>—</React.Fragment>;
        const row = envelope.rows[0];
        const value = row?.[column.name];
        const reference = row?.t ? `${envelope.query}.${column.name}[${row.t}]` : undefined;
        return (
          <span data-lens-ref={reference} key={index}>
            {formatValue(typeof value === 'number' ? value : null, column.format, {
              numbers: shown.numbers,
              decimals: column.decimals,
            })}
          </span>
        );
      })}
    </>
  );
}
